import {handleActions} from 'redux-actions'
import {constants as kandyConstants} from 'kandy-redux'
import * as types from '../../constants/ActionTypes'

const reducers = {}
reducers[kandyConstants.LOGIN] = (state, action) => {
	return {}
}

reducers[kandyConstants.LOGIN_FINISH] = {
	next (state, action) {
		if(action.error){
            return {display: true, errorText: action.payload.errInfo}
		}
		return {}
	},
	throw (state, action) {
		return {display: true, errorText: action.payload.errInfo}
	}
}

reducers[types.USER_LOGIN_FINISH] = {
    next (state, action) {
        if(action.error){
            return {display: true, errorText: action.payload.errInfo}
        }
        return {}
    },
    throw (state, action) {
        return {display: true, errorText: action.payload.errInfo}
    }
}

export default handleActions(reducers, {})
